export default "__VITE_ASSET__6f791a4c__"